import React, { useEffect, useState } from "react";

import { getStopColor } from "shared/config/results/colorConfig";
import {
  StyledIcon,
  StyledStopsDot,
  StyledStopsLine,
  StyledStopsWrapper,
} from "./styles";
import { StopsProps } from "./types";

import { Icon } from "../Icon";
import { useBreakpoint } from "shared/hooks/useBreakpoint";

/**
 * Componente Stops
 *
 * Exibe uma representação visual da quantidade de paradas em uma viagem.
 *
 * @param {number} stops - Quantidade de paradas.
 * @param {string} color - Cor aplicada à linha, dots e ícone do avião.
 */
export const Stops: React.FC<StopsProps> = ({ stops }) => {
  const color = getStopColor(stops);
  const breakpoint = useBreakpoint();
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    setMobile(breakpoint !== "xxl");
  }, [breakpoint]);

  return (
    <StyledStopsWrapper isMobile={isMobile}>
      <StyledStopsLine color={color}>
        {stops > 0 &&
          [...Array(stops)].map((_, index) => (
            <div
              key={index}
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <StyledStopsDot color={color} />
            </div>
          ))}
      </StyledStopsLine>
      <StyledIcon color={color}>
        <Icon library="md" name="MdAirplanemodeActive" size="small" />
      </StyledIcon>
    </StyledStopsWrapper>
  );
};
